export default __webpack_public_path__ + "images/EF.52a5146.png";